import {
	FORUM_FETCH,
	FORUM_SUCCESS,
	FORUM_FAILURE,
	FORUM_RESET,
	FORUM_FOLLOWING,
	THREAD_FOLLOWING
} from '../actions/ForumviewActions';

import { LOADING_BEHAVIOR } from '../actions/InfiniteScrollActions';
import merge from 'lodash/merge';
import union from 'lodash/union';

const initialState = {
	isFetching: false,
	loaded: false,
	lastError: '',
	entities: {},
	pages: [],
	result: {
		forums: [],
		topics: [],
		users: [],
		sticky: [],
    announcements: []
	},
	forumId: null,
	page: null,
	totalPages: 0,
};

export default function forumview (prevState = initialState, action) {
	switch (action.type) {
		case FORUM_FETCH:
			return Object.assign({},
				prevState,
				{
					isFetching: true,
					// Only set loaded to false if we are doing a full refresh
					loaded: !( action.forum.loadingBehavior === LOADING_BEHAVIOR.REFRESH )
				});

		case FORUM_SUCCESS:
			if (prevState.forumId !== action.forum.id || action.forum.loadingBehavior === LOADING_BEHAVIOR.REFRESH) {
				return merge(
					{},
					action.data,
					{
						isFetching: false,
						loaded: true,
						forumId: action.forum.id,
						pages: [action.data.page],
					}
				)
			} else {
				let topicsResult, usersResult, pages;
				if(action.forum.loadingBehavior === LOADING_BEHAVIOR.PREPEND) {
					topicsResult = [...action.data.result.topics, ...prevState.result.topics];
					usersResult = union(action.data.result.users, prevState.result.users);
					pages = [action.data.page,...prevState.pages]
				} else if(action.forum.loadingBehavior === LOADING_BEHAVIOR.APPEND) {
					topicsResult = [...prevState.result.topics, ...action.data.result.topics];
					usersResult = union(prevState.result.users, action.data.result.users);
					pages = [...prevState.pages, action.data.page]
				}

				return merge(
					{},
					prevState,
					action.data,
					{
						isFetching: false,
						loaded: true
					},
					{
						pages: pages,
						result: {
							topics: topicsResult,
							users: usersResult
						}
					}
				);
			}

		case FORUM_FAILURE:
			return Object.assign({}, prevState, {
				lastError: action.error
			});

		case FORUM_RESET:
			return initialState;

		case FORUM_FOLLOWING: // used only in src
			if( prevState.entities.forums ) {
				let prevEntitiesForum = prevState.entities.forums,
					forum = prevState.entities.forums[ action.forumId ];

				forum.isSubscribed = action.follow;
				let entitiesForum = {
					forums: Object.assign( {}, prevEntitiesForum, { [ action.forumId ]: forum } )
				};
				return Object.assign( {}, prevState, entitiesForum );
			}
		  return prevState;

		case THREAD_FOLLOWING:
			let prevEntitiesThread = {}, thread = {}, entities = '';
			if( prevState.entities.topics && prevState.entities.topics[ action.threadId ] ) {
				entities = 'topics';
			} else if( prevState.entities.sticky && prevState.entities.sticky[ action.threadId ] ) {
				entities = 'sticky';
			} else {
				return prevState;
			}

			prevEntitiesThread = prevState.entities[ entities ];
			thread = prevState.entities[ entities ][ action.threadId ];

			thread.isSubscribed = action.follow;
			let entitiesThreads = {
				[ entities ]: Object.assign( {}, prevEntitiesThread, { [ action.threadId ]: thread } )
			};
			return Object.assign( {}, prevState, entitiesThreads );

		default :
			return prevState;
	}
}




// WEBPACK FOOTER //
// ./common/reducers/forumview.js